module.exports = __webpack_public_path__ + "img/cloud2.a69f2b91.svg";